import { z } from 'zod'

export const addNoteSchema = z.object({
  presentationId: z.string().uuid(),
  text: z.string().nonempty(),
})

export type AddNote = z.infer<typeof addNoteSchema>
